import { IApplicationState } from 'app/types/types';
import { connect } from 'react-redux';
import { IMoveToHOCProps } from './types';
import { ICopyEvents, ICopyFields } from '../../components/Copy/types';
import { Copy } from '../../components/Copy/Copy';
import { onClick } from './events/onClick';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IMoveToHOCProps
): ICopyFields => {
    const sectionType = getSectionType(state, boardId, null, 'allowCreateBoard');
    const isDisallow = sectionType === ESettingsSectionType.DISALLOW;
    return {
        isDisallow,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IMoveToHOCProps
): ICopyEvents => {
    return {
        onClick: () => dispatch(onClick(boardId)),
    }
};

export const CopyHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Copy);

CopyHOC.displayName = 'CopyHOC';
